import { Component, Input } from "@angular/core";
import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-help-text",
	template: `
		<span
			*ngIf="text"
			[id]="id"
			class="rbc-help-text"
			[ngClass]="classGen()"
		>
			{{ text }}
		</span>
	`,
	styles: []
})
export class HelpTextComponent {
	@Input() srOnly: boolean;
	@Input() text: string;
	@Input() id: string;
	@Input() wrapperClass;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	classGen() {
		let classes = {};

		classes["sr-only"] = this.srOnly;
		classes[this.wrapperClass] = this.wrapperClass;
		return classes;
	}
}
